import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';

import { Auth } from '../../support';
import { useStore } from '../../store';
import EmpresaInfo from './info/EmpresaInfo';
import { Spinner, Col, Row } from 'react-bootstrap';
import Loading from '../../facturotopia/loading/Loading';
import EmpresaAssignacionHits from './edit/EmpresaAssignacionHits';

class EmpresasInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id },
      hits_balance: 'cliente'
    }

    props.reset();
    props.setData(this.state.data);
  }

  componentDidMount() {
    const { data } = this.state;
    const auth = Auth.getData();
    const { cliente } = auth;

    this.setState({
      hits_balance: cliente.hits_balance
    });

    if (!!data.config) {
      return;
    }

    this.props.get(data.id, { include: 'config' });
  }

  render() {
    const { hits_balance } = this.state;
    const { data = {}, busy } = this.props;
    const edit = {
      pathname: `/cuenta/empresas/${data.id}/editar`,
      state: {
        data: {...data}
      }
    }

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <div className="page-header">
          <Link to="/cuenta/empresas">
            &#8592; Todas mis empresas
          </Link>
        </div>

        <h5>
          <Row>
            <Col>
              { !!busy && (
                <Spinner animation="border" role="status" size="sm" className="mr-3">
                  <span className="sr-only">Recuperando información de empresa...</span>
                </Spinner>
              )}

              { data.nombre || '...' }
            </Col>
            { Guardian.allows('empresas.editar') && (
              <Col xs={ 2 } className="text-right">
                <Link className="text-muted"
                  to={ edit }
                >
                  <small>Editar</small>
                </Link>
              </Col>
            )}
          </Row>

        </h5>

        { !!data.nombre && (
          <div>
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <EmpresaInfo data={ data } />

            </div>
        )}

        { hits_balance === 'empresa' && Guardian.allows('empresas.asignar.hits') && (
          <>
            <div className="py-2 mt-3">
              <strong className="text-brand">ASIGNACIÓN HITS</strong>
            </div>

            <div className="mt-3">
            <EmpresaAssignacionHits data={ data } />
            </div>
          </>
        )}

      </>
    );
  }
}

const mapState = (state) => {
  return state.cuenta.empresas.info;
}

const mapActions = (actions) => {
  return actions.cuenta.empresas.info;
}

export default connect(useStore, mapState, mapActions)(EmpresasInfo);